import { useEffect } from 'react';

interface UseUnsavedChangesProps {
  hasChanges: boolean;
  onBeforeUnload?: () => void;
}

export const useUnsavedChanges = ({ hasChanges, onBeforeUnload }: UseUnsavedChangesProps) => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasChanges) {
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        
        if (onBeforeUnload) {
          onBeforeUnload();
        }
        
        return e.returnValue;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasChanges, onBeforeUnload]);

  const confirmNavigation = (message?: string): boolean => {
    if (hasChanges) {
      return window.confirm(
        message || 'You have unsaved changes. Are you sure you want to continue?'
      );
    }
    return true;
  };

  return { confirmNavigation };
};
